import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EditTracking from 'src/components/editor/EditTracking';
import { RootState } from 'src/store';

const ShortAnswerSurveyTracking: FC = () => {
  const dispatch = useDispatch();

  const currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  const tracking = useSelector((state: RootState) => state.trackings.tracking);
  const btnText = useSelector((state: RootState) => state.buttons.btnText);

  const style = `
    .root_tracking {
      background: none;

      .center_horizon {
        width: 100%;
      }
      .logo {
        opacity: 0;
      }

      .center_wrapper {
        width: 100%;
        padding: 0;
      }
      .hr {
        opacity: 0;
      }

      .textarea {
        padding: 0;
        background: transparent;
      }

      .bottom {
        height: auto;
        flex-direction: column;
      }
      .bottom button {
        height: auto;
        background: none;
      }
      
      .tracking_center {
        display: flex;
        align-items: center;
        justify-content: end;
      }
    }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_view root_tracking">
        <div className="template">
          <div className="tracking_center center_horizon top_wrapper">
            <EditTracking
              value={tracking?.close?.[currentIndex]}
              type="close"
            />
          </div>
          <div className="center_wrapper">
            <div className="title" />
            <div className="logo">
              <div className="logo_inner">
                <button />
              </div>
            </div>
            <div className="survey_wrapper">
              {btnText?.option_button?.[currentIndex]?.map(
                (_: string, idx: number) => (
                  <>
                    <div className="tracking_center survey">
                      <EditTracking
                        value={tracking?.option_button?.[currentIndex]?.[idx]}
                        idx={idx}
                        type="option_button"
                      />
                    </div>
                    {idx !==
                      btnText?.option_button?.[currentIndex]?.length - 1 && (
                      <hr className="hr" />
                    )}
                  </>
                )
              )}
            </div>
            <div className="tracking_center textarea">
              <EditTracking
                value={tracking?.text_area?.[currentIndex]}
                type="text_area"
              />
            </div>
          </div>
          <div className="center_horizon bottom">
            <button className="tracking_center left_button">
              <EditTracking
                value={tracking?.left_button?.[currentIndex]}
                type="left_button"
              />
            </button>
            <button className="tracking_center right_button">
              <EditTracking
                value={tracking?.right_button?.[currentIndex]}
                type="right_button"
              />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShortAnswerSurveyTracking;
